import { KycAndFeaturesConfig } from 'src/packages/common/header/Header.types';

export const adjustKycAndFeaturesConfig = (kycAndFeaturesConfig?: KycAndFeaturesConfig) => {
  const getFieldValue = (key: keyof KycAndFeaturesConfig): boolean =>
    kycAndFeaturesConfig?.[key] !== undefined ? !!kycAndFeaturesConfig[key] : true;

  return {
    allowDeposit: getFieldValue('allowDeposit'),
    allowWithdrawal: getFieldValue('allowWithdrawal'),
    allowOnboarding: getFieldValue('allowOnboarding'),
    allowTrading: getFieldValue('allowTrading'),
    earnPlatformEnabled: getFieldValue('earnPlatformEnabled'),
    convertPlatformEnabled: getFieldValue('convertPlatformEnabled'),
    p2pPlatformEnabled: getFieldValue('p2pPlatformEnabled'),
    tradeSpotPlatformEnabled: getFieldValue('tradeSpotPlatformEnabled'),
    tradeDerivativesPlatformEnabled: getFieldValue('tradeDerivativesPlatformEnabled'),
    enabledSymbols: kycAndFeaturesConfig?.enabledSymbols,
  };
};
